export const SCHEDULER_QUERY_KEYS = {
  LIST_EMPLOYEES: 'employees',
  LIST_EQUIPMENTS: 'equipment',
  LIST_PROJECTS: 'projects',
  LIST_SHIFTS: 'shifts',
} as const;
